var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState, } from 'react';
import { Flex, Paragraph, Responsive, Button, } from '@stepstone-genesis/components';
import { UploadIcon } from '@stepstone-genesis/icons';
import { Base, useTheme } from '@stepstone-genesis/system';
import { FileInputButton } from '../FileInput';
import { UploadProgressBar } from '../UploadProgressBar';
import { getLabel, replacePlaceholders, } from '../../utils/helpers/labelsService';
import { MODAL_DATA_AT } from '../consts';
export var UploadArea = function (_a) {
    var _b, _c, _d;
    var uploadPercentage = _a.uploadPercentage, uploadedFileName = _a.uploadedFileName, _e = _a.uploading, uploading = _e === void 0 ? true : _e, dataAt = _a.dataAt, handleUpload = _a.handleUpload, fileConfig = _a.fileConfig;
    var theme = useTheme().theme;
    var _f = useState(false), highlight = _f[0], setHighlight = _f[1];
    var _g = useState(0), counter = _g[0], setCounter = _g[1];
    useEffect(function () {
        if (!highlight && counter > 0) {
            setHighlight(true);
        }
        else if (counter === 0 && highlight) {
            setHighlight(false);
        }
    }, [counter]);
    var handleDrop = function (event) {
        var _a, _b;
        stopPropagationAndPreventDefault(event);
        if ((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files.length) {
            handleUpload((_b = event.dataTransfer) === null || _b === void 0 ? void 0 : _b.files[0]);
        }
    };
    var commonProps = {
        'data-at': dataAt,
        flxDirection: 'column',
        flxJustify: 'center',
        sx: {
            alignItems: 'center',
            width: '100%',
            height: 'auto',
            padding: "".concat((_b = theme.space) === null || _b === void 0 ? void 0 : _b.spaceL, " ").concat((_c = theme.space) === null || _c === void 0 ? void 0 : _c.spaceM),
            textAlign: 'center',
            border: '1px dashed',
            borderColor: highlight ? theme.colors.colorAccentB2BDefault : 'inherit',
            borderRadius: (_d = theme.space) === null || _d === void 0 ? void 0 : _d.spaceM,
        },
    };
    return (React.createElement(Flex, __assign({}, commonProps, { onDrop: handleDrop, onDragEnter: function (e) {
            stopPropagationAndPreventDefault(e);
            setCounter(function () { return counter + 1; });
        }, onDragOver: stopPropagationAndPreventDefault, onDragLeave: function (e) {
            stopPropagationAndPreventDefault(e);
            setCounter(function () { return counter - 1; });
        } }), uploading ? (React.createElement(UploadProgressBar, { value: uploadPercentage, fileName: uploadedFileName })) : (React.createElement(Content, { fileConfig: fileConfig, handleUpload: handleUpload }))));
};
var Content = function (_a) {
    var handleUpload = _a.handleUpload, _b = _a.fileConfig, replacers = _b.replacers, limits = _b.limits;
    var uploadLabels = getLabel('cvDropZone');
    return (React.createElement(Flex, { flxDirection: 'column', flxWrap: "nowrap", flxJustify: "space-between", sx: {
            width: '100%',
            alignItems: 'center',
            height: '100%',
        } },
        React.createElement(UploadIcon, { color: "colorGreyDark", size: "xxl", mr: 'spaceNone', mb: 'spaceM', sx: { flexShrink: 0 } }),
        React.createElement(Base, { sx: {
                flexShrink: 0,
                width: '100%',
                marginTop: ['spaceNone', 'spaceM'],
                marginBottom: ['spaceM', 'spaceNone'],
                order: [0, 1],
            } },
            React.createElement(FileInputButton, { dataAt: MODAL_DATA_AT, accept: limits.supportedMimeTypes.join(), label: uploadLabels.uploadButton, fileListHandler: function (file) { return handleUpload(file[0]); }, renderButton: [
                    React.createElement(Button, { key: uploadLabels.uploadButton, a11yLabel: uploadLabels.uploadButton, "data-at": "".concat(MODAL_DATA_AT, "-upload-area-bt"), iconBefore: React.createElement(UploadIcon, { color: "colorWhite" }), size: "medium", sx: {
                            width: '100%',
                            '>span': {
                                flexWrap: 'nowrap',
                            },
                        } }, uploadLabels.uploadButton),
                ] })),
        React.createElement(Flex, { flxDirection: "column", flxShrink: 1, flxJustify: 'flex-start', sx: {
                height: '100%',
            } },
            React.createElement(Responsive, { above: "xs" },
                React.createElement(Paragraph, { fontWeight: "fontWeightBold", mb: 'spaceS' }, uploadLabels.info)),
            React.createElement(Paragraph, { color: "colorGreyDark" }, replacePlaceholders(uploadLabels.hint, replacers)))));
};
var stopPropagationAndPreventDefault = function (event) {
    event.stopPropagation();
    event.preventDefault();
};
//# sourceMappingURL=index.js.map